<template>
<div style="width: 100%;">


<!-- Фильтрация аккаунтов -->
<div style="margin-bottom:25px">
<b-form-checkbox size="lg"  v-model="filters.is">Фильтровать таблицу</b-form-checkbox>
</div>

<div v-if="filters.is">
  <b-tabs content-class="mt-3" justified>
<b-tab title="Списки аккаунтов" active>
<b-checkbox v-model="filters.cats.lists.mainList.is" ><span @click="addList(1,!filters.cats.lists.mainList.is)">Основной список</span></b-checkbox>
<b-checkbox v-model="filters.cats.lists.friendList.is" ><span @click="addList(3,!filters.cats.lists.friendList.is)">Для друзей список</span></b-checkbox>
<b-checkbox v-model="filters.cats.lists.autoregList.is" ><span @click="addList(2,!filters.cats.lists.autoregList.is)">Автореги список</span></b-checkbox>
<b-checkbox v-model="filters.cats.lists.othersList.is" ><span @click="addList(4,!filters.cats.lists.othersList.is)">Другое список</span></b-checkbox>
</b-tab>

<b-tab title="Валидность">
<b-checkbox  v-model="filters.cats.valid.valid.is"><span @click="addValid(!filters.cats.valid.valid.is)">Валидные </span></b-checkbox>
<b-checkbox v-model="filters.cats.valid.invalid.is"><span @click="addInvalid(!filters.cats.valid.invalid.is)">Невалидные</span></b-checkbox>
</b-tab>

<b-tab title="Прокси">
<b-checkbox v-model="filters.cats.proxy.with.is"><span @click="addWithProxy(!filters.cats.proxy.with.is)">С прокси</span></b-checkbox>
<b-checkbox v-model="filters.cats.proxy.without.is"><span @click="addWithoutProxy(!filters.cats.proxy.without.is)">Без прокси</span></b-checkbox>
</b-tab>




  </b-tabs>
</div>

<!-- Фильтрация аккаунтов закрываем-->



</div>
</template>




<script>
import axios from 'axios'

export default {
props:['accounts','filters'],
components:{},
 data(){
  return {

  }
},


created(){

},



methods:{

addList(listId,mode){
if(mode){
let aki = this.accounts.items.filter(item =>{
return item.grId == listId
})
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.concat(aki)
}
if(!mode){
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.filter(item =>{
return item.grId != listId
})
}
return this.accounts.itemsToDisplay
},

addValid(mode){
if(mode){
let aki = this.accounts.items.filter(item =>{
return item.valid == 1
})
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.concat(aki)
}
if(!mode){
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.filter(item =>{
return item.valid != 1
})
}
return this.accounts.itemsToDisplay
},

addInvalid(mode){
if(mode){
let aki = this.accounts.items.filter(item =>{
return item.valid != 1
})
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.concat(aki)
}
if(!mode){
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.filter(item =>{
return item.valid != 0
})
}
return this.accounts.itemsToDisplay
},

addWithProxy(mode){
if(mode){
let aki = this.accounts.items.filter(item =>{
return item.proxy != ''
})
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.concat(aki)
}
if(!mode){
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.filter(item =>{
return item.proxy == ''
})
}
return this.accounts.itemsToDisplay
},

addWithoutProxy(mode){
if(mode){
let aki = this.accounts.items.filter(item =>{
return item.proxy == ''
})
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.concat(aki)
}
if(!mode){
this.accounts.itemsToDisplay = this.accounts.itemsToDisplay.filter(item =>{
return item.proxy != ''
})
}
return this.accounts.itemsToDisplay
},

}
}
</script>

<style>

</style>
